<template>

    <div id="sild">
        <div class="sidebar">
            <el-menu class="sidebar-el-menu" text-color="#999" unique-opened @open="open" @close="close" router>
                <template v-for="item in items">
                    <template>
                        <el-submenu :index="item.index" :key="item.id">
                            <template slot="title">
                                <i :class="item.icon"></i>
                                <span slot="title">{{ item.title }}</span>
                            </template>
                        </el-submenu>
                    </template>
                </template>
            </el-menu>
        </div>
        <div class="sidebar width" v-if="subs">
            <el-menu class="sidebar-el-menu" :default-active="$router.path" text-color="#333" unique-opened @open="openSubs" @select="select">
                <el-submenu :index="item.index" :key="item.index" v-for="item in subs">
                    <template slot="title">
                        <span>{{ item.title }}</span>
                    </template>
                </el-submenu>
            </el-menu>
        </div>
    </div>
</template>

<script>
import { mapState, mapGetters } from "vuex";
import bus from '../common/bus';
import { getUserInfo } from "../utils/user";
export default {
    data() {
        return {
            collapse: false,
            adminRouterList: [],   //管理员角色所赋予的路由
            isSuperAdmin: false,

            items: [],//可访问的路由表

            // items: [
            //     {
            //         icon: 'el-icon-lx-home',
            //         index: '/survey',
            //         title: '概况',
            //         subs: [
            //             {
            //                 index: '/survey-Dashboard',
            //                 title: '运营概况',
            //                 id: 1
            //             },
            //             {
            //                 index: '/survey-BigScreen',
            //                 title: '数据大屏',
            //                 id: 2
            //             },]
            //     },
            //     {
            //         icon: 'el-icon-shopping-bag-1',
            //         index: '/shop',
            //         title: '店铺',
            //         subs: [{
            //             index: '/shop-Banner',
            //             title: '幻灯片',
            //             id: 1
            //         },
            //         {
            //             index: '/shop-Ad',
            //             title: '广告',
            //             id: 2
            //         },
            //         {
            //             index: '/shop-nav',
            //             title: '导航图标',
            //             id: 3
            //         },
            //         {
            //             index: '/shop-painmanagement',
            //             title: '页面配置',
            //             id: 4
            //         },
            //         {
            //             index: '/shop-locationss',
            //             title: '位置管理',
            //             id: 5
            //         },
            //         {
            //             index: '/shop-hotwordlist',
            //             title: '标签管理',
            //             id: 6
            //         },
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-goods',
            //         index: '/product',
            //         title: '商品',
            //         subs: [{
            //             index: '/product-list',
            //             title: '商品管理',
            //             id: 42,
            //         },
            //         {
            //             index: '/product-sort',
            //             title: '商品分类',
            //             id: 45,
            //         },
            //         {
            //             index: '/product-Chinacom',
            //             title: '中台商品',
            //             id: 90,
            //         },
            //         {
            //             index: '/product-Brand',
            //             title: '品牌管理',
            //             id: 38,
            //         },
            //         {
            //             index: '/product-Commodity',
            //             title: '商品评价',
            //             id: 91,
            //         },
            //         {
            //             index: '/product-Commod',
            //             title: '商品分组',
            //             id: 41,
            //         },
            //         {
            //             index: '/product-Template',
            //             title: '商品模板',
            //             id: 43,
            //         },
            //             // {
            //             //     index: '/product-Transaction',
            //             //     title: '交易明细',
            //             //     id: 46,
            //             // },
            //             // {
            //             //     index: '/product-batch',
            //             //     title: '批量导入',
            //             //     id: 40,
            //             // },
            //             // {
            //             //     index: '/goodsLabel',
            //             //     title: '商品标签',
            //             //     id: 39,
            //             // },

            //         ]
            //     },
            //     {
            //         icon: 'el-icon-data-line',
            //         index: '/activity',
            //         title: '营销',
            //         subs: [{
            //             index: '/activity-Discount',
            //             title: '优惠券管理',
            //             id: 1,
            //         },
            //         {
            //             index: '/activity-CouponCollection',
            //             title: '优惠券领取',
            //             id: 2,
            //         },

            //         {
            //             index: '/activity-Withsend',
            //             title: '满送券',
            //             id: 3,
            //         },
            //         {
            //             index: '/activity-Session',
            //             title: '专场管理',
            //             id: 4,
            //         },
            //         {
            //             index: '/activity-SeckillSessionList',
            //             title: '秒杀专场',
            //             id: 4,
            //         },
            //         {
            //             index: '/activity-SignActivityList',
            //             title: '签到活动',
            //             id: 4,
            //         },
            //         {
            //             index: '/activity-Storedvalue',
            //             title: '储值活动',
            //             id: 5,
            //         },
            //         {
            //             index: '/activity-PriceIncrease',
            //             title: '加价设置',
            //             id: 8,
            //         },
            //         {
            //             index: '/activity-Suitfor',
            //             title: '套装购',
            //             id: 6,
            //         },

            //         {
            //             index: '/activity-Manypeople',
            //             title: '多人拼团',
            //             id: 7,
            //         },
            //         ],
            //     },
            //     {
            //         icon: 'el-icon-s-order',
            //         index: '/order',
            //         title: '订单',
            //         subs: [
            //             {
            //                 index: '/order-orderList',
            //                 title: '订单管理',
            //                 id: 24,
            //             },
            //             {
            //                 index: '/order-salesorders',
            //                 title: '售后订单',
            //                 id: 25,
            //             },
            //             {
            //                 index: '/order-MiniSalesOrders',
            //                 title: '小程序售后',
            //                 id: 25,
            //             },
            //             {
            //                 index: '/order-CollageOrder',
            //                 title: '拼团订单',
            //                 id: 26,
            //             },
            //             {
            //                 index: '/order-CollageInfo',
            //                 title: '拼团信息',
            //                 id: 27,
            //             },

            //         ]
            //     },
            //     {
            //         icon: 'el-icon-user',
            //         index: '/custom',
            //         title: '客户',
            //         subs: [{
            //             index: '/custom-list',
            //             title: '客户管理',
            //             id: 1,
            //         },
            //         {
            //             index: '/custom-grade',
            //             title: '客户等级',
            //             id: 2,
            //         }, {
            //             index: '/shop-hotwordlist',
            //             title: '客户标签',
            //             id: 4,
            //         },
            //         {
            //             index: '/custom-Userauthen',
            //             title: '客户认证',
            //             id: 4,
            //         },
            //         {
            //             index: '/custom-RankOrder',
            //             title: '等级订单',
            //             id: 4,
            //         },
            //         {
            //             index: '/custom-RankGoods',
            //             title: '升级配置',
            //             id: 5,
            //         },
            //         {
            //             index: '/custom-StoreManage',
            //             title: '店铺管理',
            //             id: 5,
            //         },

            //         ]
            //     },
            //     {
            //         icon: 'el-icon-wallet',
            //         index: '/capital',
            //         title: '资金',
            //         subs: [
            //             {
            //                 index: '/capital-Banklist',
            //                 title: '银行卡',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/capital-Transaction',
            //                 title: '交易明细',
            //                 id: 2,
            //             },
            //             {
            //                 index: '/capital-WithdrawalRecord',
            //                 title: '提现审核',
            //                 id: 4,
            //             },
            //             {
            //                 index: '/merchant-account',
            //                 title: '我的账户',
            //                 id: 4,
            //             },

            //         ]
            //     },
            //     {
            //         icon: 'el-icon-mic',
            //         index: '/manags',
            //         title: '直播',
            //         subs: [
            //             {
            //                 index: '/manags-student',
            //                 title: '直播管理',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/manags-Roomconfig',
            //                 title: '直播配置',
            //                 id: 2,
            //             },
            //             {
            //                 index: '/manags-livegod',
            //                 title: '直播商品',
            //                 id: 3,
            //             },
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-office-building',
            //         index: '/community',
            //         title: '社区',
            //         subs: [{
            //             index: '/community-Article',
            //             title: '资源管理',
            //             id: 60
            //         },
            //         {
            //             index: '/community-Comment',
            //             title: '社区评论',
            //             id: 64
            //         },
            //         {
            //             index: '/community-Topics',
            //             title: '话题管理',
            //             id: 62
            //         },
            //         {
            //             index: '/community-Lettres',
            //             title: '文章管理',
            //             id: 62
            //         },
            //         {
            //             index: '/community-Column',
            //             title: '文章栏目',
            //             id: 62
            //         },
            //         {
            //             index: '/community-Banners',
            //             title: 'banner管理',
            //             id: 63
            //         }
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-s-operation',
            //         index: '/sale',
            //         title: '功能',
            //         subs: [
            //             {
            //                 index: '/sale-codelist',
            //                 title: '邀请码管理',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/sale-Plugintable',
            //                 title: '插件表管理',
            //                 id: 2,
            //             },
            //             {
            //                 index: '/sale-Lnvitation',
            //                 title: '邀请码订单',
            //                 id: 3,
            //             },
            //             {
            //                 index: '/sale-Plugingoods',
            //                 title: '邀请码商品',
            //                 id: 4,
            //             },
            //             {
            //                 index: '/sale-distri',
            //                 title: '物流管理',
            //                 id: 5
            //             },
            //             {
            //                 index: '/sale-SensitiveWords',
            //                 title: '敏感词管理',
            //                 id: 6
            //             },
            //             {
            //                 index: '/sale-BusinessWords',
            //                 title: '业务方敏感词',
            //                 id: 6
            //             },
            //             {
            //                 index: '/sale-Business',
            //                 title: '敏感词业务',
            //                 id: 7
            //             },
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-s-cooperation',
            //         index: '/access-set',
            //         title: '权限',
            //         subs: [
            //             {
            //                 index: '/set-users',
            //                 title: '管理员管理',
            //                 id: 5
            //             },
            //             {
            //                 index: '/set-SlidList',
            //                 title: '菜单配置',
            //                 id: 34
            //             },
            //             {
            //                 index: '/set-RoleList',
            //                 title: '角色配置',
            //                 id: 34
            //             },
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-setting',
            //         index: '/set',
            //         title: '设置',
            //         subs: [
            //             {
            //                 index: '/set-store-info',
            //                 title: '商城信息',
            //                 id: 1
            //             },
            //             {
            //                 index: '/set-AppColor',
            //                 title: 'app配色',
            //                 id: 2
            //             },
            //             {
            //                 index: '/set-trade',
            //                 title: '交易设置',
            //                 id: 3
            //             },
            //             {
            //                 index: '/set-Poster',
            //                 title: '海报设置',
            //                 id: 4
            //             },
            //             {
            //                 index: '/set-versionings',
            //                 title: '版本管理',
            //                 id: 6
            //             },
            //             {
            //                 index: '/set-Pageconfigure',
            //                 title: '系统配置',
            //                 id: 7
            //             },
            //             {
            //                 index: '/set-Weixin',
            //                 title: '微信配置',
            //                 id: 8
            //             },
            //             {
            //                 index: '/set-BuryingPoint',
            //                 title: '埋点配置',
            //                 id: 9
            //             },
            //             // {
            //             //     index: '/set-Domain',
            //             //     title: '域名配置',
            //             //     id: 10
            //             // },
            //             {
            //                 index: '/set-Urllist',
            //                 title: '链接配置',
            //                 id: 35
            //             },
            //             {
            //                 index: '/set-CommentSet',
            //                 title: '评论设置',
            //                 id: 48,
            //             },
            //             {
            //                 index: '/set-Agreement',
            //                 title: '协议管理',
            //                 id: 26
            //             },

            //             {
            //                 index: '/set-Distribution',
            //                 title: '配送设置',
            //                 id: 31
            //             },
            //             {
            //                 index: '/set-notes',
            //                 title: '助通短信',
            //                 id: 32
            //             }
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-menu',
            //         index: '/lineage',
            //         title: '系统',
            //         subs: [

            //             {
            //                 index: '/lineage-Journal',
            //                 title: '后台日志',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/lineage-Download',
            //                 title: '下载',
            //                 id: 6,
            //             },
            //             {
            //                 index: '/lineage-Feedback',
            //                 title: '建议反馈',
            //                 id: 2,
            //             },
            //             {
            //                 index: '/lineage-Classification',
            //                 title: '建议分类',
            //                 id: 4,
            //             },
            //             {
            //                 index: '/lineage-Logmanagement',
            //                 title: '日志管理',
            //                 id: 5
            //             },
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-service',
            //         index: '/workbench',
            //         title: '客服',
            //         subs: [
            //         ]
            //     },
            //     {
            //         icon: 'el-icon-bell',
            //         index: '/news',
            //         title: '消息',
            //         subs: [
            //             {
            //                 index: '/news-Template',
            //                 title: '消息模板',
            //                 id: 3,
            //             },
            //             {
            //                 index: '/news-Push',
            //                 title: '发送消息',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/news-Gw',
            //                 title: '官网消息',
            //                 id: 4,
            //             },

            //         ]
            //     },
            //     {
            //         icon: 'el-icon-bell',
            //         index: '#/vue-son',
            //         title: '子系统',
            //         subs: [
            //             {
            //                 index: '/vue-son/tab/tab',
            //                 title: '子应用1',
            //                 id: 1,
            //             },
            //             {
            //                 index: '/vue-son/documentation/documentation',
            //                 title: '子应用2',
            //                 id: 2,
            //             },
            //         ]
            //     },
            // ],
            activeIndex: '',

            //  仅开放社区模块的名单列表
            commList: [
                '15026473653',
                '17302501365'
            ],
            subs: null,
        };
    },
    watch: {
        $router() {
            this.select(this.activeIndex)
        },
        adminRouterList() {
            this.adminRouterList = this.GET_ADMIN_ROUTER
        },

        siderRouter(val) {
            this.items = val;
        },
    },
    methods: {
        open(index) {
            this.setTopMenuTage(index)
            let subs = []
            this.items.map(item => {
                if (item.index === index) {
                    subs = item.subs
                }
                return subs
            })
            this.subs = subs
            if (this.subs) {
                this.$emit('width', 240)
            } else {
                this.$emit('width', 120)
                this.$router.push({ path: index })
            }
        },
        close() {
            this.$emit('width', 120)
        },
        openSubs(index) {
            this.$store.commit('initQueryParams', { page: 1, pagesize: 10 })
            this.$router.push({ path: index })
        },
        select(index) {
            this.activeIndex = index
        },
        setTopMenuTage(tag) {
            this.$store.dispatch("adminRouter/SET_TOP_MENU_TAG", tag).then((res) => {
            }).catch(() => {
                that.$message.error("设置左侧菜单标签错误");
            });
        }
    },
    computed: {
        ...mapState("adminRouter", ["adminRouter", "siderRouter"]),
        ...mapGetters("adminRouter", ["GET_ADMIN_ROUTER", "get_siderRouter"]),
        onRoutes() {
            return this.$route.path.replace('/', '');
        }
    },

    updated() {

    },

    mounted() {
        this.$nextTick(() => {
            let silist = this.$store.getters['adminRouter/get_siderRouter'];
            this.items = silist;
        })
    },

    created() {

        let admin = getUserInfo()
        if (admin.is_super_admin) {
            this.isSuperAdmin = true
        }
        this.adminRouterList = this.GET_ADMIN_ROUTER


        /*for (const item of this.items) {
          if (this.adminRouterList.indexOf(item.index)){

          }
        }*/

        // 通过 Event Bus 进行组件间通信，来折叠侧边栏
        let phone = localStorage.getItem('ms_username');
        if (this.commList.indexOf(phone) > -1) {
            this.items = [
                {
                    icon: 'el-icon-lx-home',
                    index: '/dashboard',
                    title: '概况'
                },
                {
                    icon: 'el-icon-office-building',
                    index: '/community',
                    title: '社区',
                    subs: [{
                        index: '/community-Article',
                        title: '资源管理',
                        id: 60
                    },
                        {
                            index: '/community-Topics',
                            title: '话题管理',
                            id: 62
                        },
                        {
                            index: '/community-Banners',
                            title: 'banner管理',
                            id: 63
                        }
                    ]
                },
            ]
        }

    },
};
</script>

<style scoped>
#sild {
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;

    /* width: 240px; */
}
.sidebar >>> .el-menu {
    background: #031225;
}

.width >>> .el-submenu__title i {
    display: none;
}

#sild .sidebar {
    display: inline-block;
    height: 100%;
    overflow-y: scroll;
    width: 120px;
}

#sild .sidebar >>> .el-submenu__title {
    background: #031225;
}

#sild .sidebar >>> .is-opened .el-submenu__title {
    background: #409eff;
}

#sild .sidebar >>> .is-opened .el-submenu__title span {
    color: #fff;
}

#sild .sidebar >>> .is-opened .el-submenu__title i {
    color: #fff;
}

#sild .width >>> .el-submenu__title {
    text-align: center;
    background: #fff;
}

#sild .width >>> .is-opened .el-submenu__title {
    background-color: rgba(3, 18, 37, 0.1);
}

#sild .width >>> .is-opened .el-submenu__title span {
    color: #409eff;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 120px;
}

.sidebar > ul {
    height: 100%;
}

#sild {
    display: block;
    position: absolute;
    left: 0;
    top: 50px;
    bottom: 0;
    /* width: 240px; */
}

.sidebar-el-menu {
    background: #041040;
}

.width .sidebar-el-menu {
    background: #ffffff;
}

.width >>> .el-submenu__title i {
    display: none;
}

.sidebar::-webkit-scrollbar {
    width: 0;
}

.sidebar-el-menu:not(.el-menu--collapse) {
    width: 120px;
}

.sidebar > ul {
    height: 100%;
}
</style>
